import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Home } from './pages/home/index';
import { Music } from './pages/music/index';
import React, { useEffect } from "react";

function RedirectToLedgeList() {
  useEffect(() => {
    window.location.href = "https://ledgelist.netlify.app/";
  }, []);

  return null; // nothing is rendered while redirecting
}

function RedirectToShop() {
  useEffect(() => {
    window.location.href = "https://shop.sdslayer.com/";
  }, []);

  return null; // nothing is rendered while redirecting
}

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/music" element={<Music />} />

          <Route path="/list" element={<RedirectToLedgeList />} />

          <Route path="/shop" element={<RedirectToShop />} />

          <Route path="/store" element={<RedirectToShop />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
